export default __webpack_public_path__ + "static/media/heart-face.3873929e.png";